/**
 * ThreadInfobar — shows entities connected to the email thread.
 * Renders people, buildings, tasks, etc. from the thread.infobar JSON.
 */

import { h } from 'preact'
import { PersonAvatar } from './PersonAvatar.jsx'

export function ThreadInfobar({ infobar, emailId, store, i18n }) {
  const labels = infobar.labels || {}
  const SECTIONS = [
    { key: 'people',             icon: null,              label: labels.people             || 'Személyek' },
    { key: 'building_complexes', icon: 'bi-buildings',    label: labels.building_complexes || 'Társasházak' },
    { key: 'buildings',          icon: 'bi-house',         label: labels.buildings          || 'Épületek' },
    { key: 'properties',         icon: 'bi-door-closed',  label: labels.properties         || 'Ingatlanok' },
    { key: 'areas',              icon: 'bi-map',           label: labels.areas              || 'Területek' },
    { key: 'companies',          icon: 'bi-building',      label: labels.companies          || 'Vállalkozások' },
  ]
  const sections = SECTIONS.map(s => ({
    ...s,
    items: infobar[s.key] || [],
  })).filter(s => s.items.length > 0)

  const tasks = infobar.tasks || []
  const tasksLabel = labels.tasks || 'Feladatok'

  const hasConnections = sections.length > 0 || tasks.length > 0

  async function handleUnlinkTask(connectionId) {
    await store.unlinkTask(connectionId)
  }

  return (
    <div class="email-thread-infobar p-3">

      {/* Header */}
      <div class="d-flex align-items-center gap-2 mb-3 pb-2 border-bottom">
        <i class="bi bi-diagram-3 text-muted" />
        <span class="fw-semibold small">{i18n?.t('emails.connections_title')}</span>
      </div>

      {/* Entity sections */}
      {sections.map(section => (
        <div key={section.key} class="mb-3">
          <div class="text-muted small fw-semibold mb-1 text-uppercase" style="font-size:0.7rem">
            {section.label}
          </div>
          {section.items.map(item => (
            <div key={item.id} class="d-flex align-items-center gap-2 py-1">
              {section.key === 'people'
                ? <PersonAvatar avatarUrl={item.avatar_url} name={item.name} size={24} cssClass="flex-shrink-0" />
                : <i class={`bi ${section.icon} text-muted small flex-shrink-0`} />
              }
              {item.path
                ? <a href={item.path} class="small text-truncate text-decoration-none" title={item.name}>{item.name}</a>
                : <span class="small text-truncate">{item.name}</span>
              }
            </div>
          ))}
        </div>
      ))}

      {/* Tasks */}
      {tasks.length > 0 && (
        <div class="mb-3">
          <div class="text-muted small fw-semibold mb-1 text-uppercase" style="font-size:0.7rem">
            {tasksLabel}
          </div>
          {tasks.map(task => (
            <div key={task.id} class="d-flex align-items-center gap-2 py-1">
              <i class="bi bi-check2-square text-muted small flex-shrink-0" />
              <a
                href={task.path}
                class="small text-truncate text-decoration-none flex-grow-1"
                target="_blank"
                rel="noopener noreferrer"
              >
                {task.name}
              </a>
              {task.connection_id && (
                <button
                  class="btn btn-link btn-sm p-0 text-muted flex-shrink-0"
                  title={i18n?.t('emails.unlink_task')}
                  onClick={() => handleUnlinkTask(task.connection_id)}
                >
                  <i class="bi bi-x-lg" style="font-size:0.7rem" />
                </button>
              )}
            </div>
          ))}
        </div>
      )}

      {/* Empty state */}
      {!hasConnections && (
        <div class="text-muted small text-center py-3">
          <i class="bi bi-link-45deg d-block mb-1 opacity-50" style="font-size:1.5rem" />
          {i18n?.t('emails.no_connections')}
        </div>
      )}

    </div>
  )
}
